<template>
    <div class="form-group" :class="inputError ? '' : ''">
        <div v-if="loading">
            Загружается...
        </div>
        <img v-else :src="imageBase64" alt="Загружается...">
        <div class="form-group field-code mt20" :class="inputError ? 'has-error' : ''">
            <input id="code"
                   ref="code"
                   v-model.trim="code"
                   type="text"
                   class="form-control"
                   placeholder="Введите код с картинки"
                   @input="onInput"
                   @keyup.enter="onEnter"
            >
            <div v-if="inputError" class="help-block">{{ inputError }}</div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';

export default {
    props: {
        error: {
            type: String,
        },
        captchaUrl: {
            type: String,
        },
        modelValue: {
            type: String,
        },
    },
    emits: ['enter', 'update:modelValue', 'update'],
    data() {
        return {
            loading: true,
            code: this.modelValue,
            imageUrl: null,
            imageBase64: null
        };
    },
    computed: {
        inputError() {
            return this.error;
        },
    },
    async mounted() {
        const url = new URL('https://site.ru' + this.captchaUrl);
        if (url.searchParams.has('refresh')) {
            const resp = await axios.get(this.captchaUrl,{withCredentials: true});
            this.imageBase64 = await this.urlBase64(resp.data.url);
        } else {
            this.imageBase64 = await this.urlBase64(this.captchaUrl);
        }

        this.loading = false;

        this.$nextTick(() => {
            this.$refs.code.focus();
        });
    },
    methods: {
        onEnter() {
            this.$emit('enter');
        },
        onInput() {
            this.$emit('update:modelValue', this.code);
            this.$emit('update', this.code);
        },
        async urlBase64(url) {
            const response = await axios.get(url, { responseType: 'arraybuffer' });
            return `data:${response.headers['Content-Type']};base64,${btoa(String.fromCharCode(...new Uint8Array(response.data)))}`;
        }
    }
};
</script>
